module.exports = __webpack_public_path__ + "shared/assets/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/favicon.ico
// module id = 7646
// module chunks = 0